import { render, staticRenderFns } from "./IconButtonContinue.vue?vue&type=template&id=25e3f7a8&scoped=true"
import script from "./IconButtonContinue.vue?vue&type=script&lang=js"
export * from "./IconButtonContinue.vue?vue&type=script&lang=js"
import style0 from "./IconButtonContinue.vue?vue&type=style&index=0&id=25e3f7a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e3f7a8",
  null
  
)

export default component.exports